/** Wrapper for all the vendor services */

import type { FC, PropsWithChildren } from 'react'
import { useCrisp } from './crisp/crisp.hook.js'
import { Posthog } from './posthog/posthog.js'
import { useSentry, sentryStyles } from './sentry/sentry.hook.js'
import { useTunaColorScheme } from '@tunasong/ui-lib'

const crispStyles = {
  '--crisp-customization-container-index': '1000000',
  '--crisp-customization-default-button-horizontal': '0px',
  '--crisp-customization-default-button-vertical': '32px',
  '--crisp-customization-mobile-button-horizontal': '0px',
  '--crisp-customization-mobile-button-vertical': '32px',
}

const globalStylesCSS = `
:root {
  ${Object.entries({ ...sentryStyles, ...crispStyles })
    .map(([k, v]) => `${k}: ${v}`)
    .join(';\n  ')};
}
html body .crisp-client {
  ${Object.entries(crispStyles)
    .map(([k, v]) => `${k}: ${v}`)
    .join(';\n  ')};
}
`

export const VendorServices: FC<PropsWithChildren> = ({ children }) => {
  const { colorScheme = 'light' } = useTunaColorScheme()

  useSentry({ mode: colorScheme })

  /** Crisp communication with users */
  useCrisp()

  return (
    <Posthog>
      <style dangerouslySetInnerHTML={{ __html: globalStylesCSS }} />
      {children}
    </Posthog>
  )
}
